import { useAPI, useValidator } from '@arema/components/Hooks';
import { fromJSDate, getNow } from '@arema/components/Util';
import React, { useEffect, useState } from 'react';
import { Button, Dropdown, Field, Groupper, Input, Message } from 'react-frontier2';
import { useTranslation } from 'react-i18next';
import API from '../../API';

interface BuyersReportProps{
	
}

var BuyersReport = (props: BuyersReportProps)=>{
	var { t } = useTranslation();
	var { load: loadQL, data: ql } = useAPI(API.getEventsQL);
	var { data, onDataChange, prompts, validate } = useValidator({
		date_start: getNow().minus({ year: 1 }).toJSDate(),
		date_end: getNow().toJSDate(),
		city: null,
	}, {
		city: ['empty'],
		date_end: ['empty'],
		date_start: ['empty']
	});
	var { load: loadBuyers, data: buyers, loading: buyersLoading, loadError } = useAPI(API.getCityBuyers);

	useEffect(()=>{
		loadQL(['cities']);
	}, []);

	var getData = ()=>{
		var { valid } = validate();
		if(!valid) return;
		
		var ds = fromJSDate(data.date_start).startOf('month');
		var de = fromJSDate(data.date_end).endOf('month');

		loadBuyers(ds.toSeconds(), de.toSeconds(), data.city);
	}
	
	return <>
		<Groupper title={'Compradores'} style={{ maxWidth: 500 }} actions={(
			<Button text={t('common.send')} color={'black'} onClick={getData} loading={buyersLoading} />
		)}>
			<Field>
				<Input label='Inicio' calendar={{
					mode: 'month',
					date: data.date_start,
					format: 'MMM yyyy',
					onSelected: onDataChange('date_start'),
				}} />
				<Input label='Fin' calendar={{
					mode: 'month',
					date: data.date_end,
					format: 'MMM yyyy',
					onSelected: onDataChange('date_end'),
				}} />
			</Field>
			<Dropdown search label='Ciudad' value={data.city} onValueChange={onDataChange('city')} items={ql?.cities.sort((a,b)=>a.city-b.city).map(a=>({
				value: a.city,
				text: a.city,
				meta: t('common.venues', { count: a.venues }),
			})) || []} loading={!ql} />
			<Message type='error' list={prompts} />
			{loadError && (
				<Message type='error' text={loadError} />
			)}
		</Groupper>
	</>
}

export default BuyersReport;